<template>
  <BaseTemplate :currentUser="currentUser" :isLineup="true">
    <div class="pack-detail">
      <Title :jpn="t('ラインナップ')" :showBackButton="true" :packItem="currentPack" ref="scrollTarget" />
      <div v-if="cardList" class="card_list_area" >
        <div class="card_list">
          <CardList
            v-if="cardList && cardList.list && cardList.list.length > 0"
            class="card-list return-point"
            :page="page"
            :cardListTitle="null"
            :isList="true"
            :cardList="
              cardList.list.map((card) => ({
                id: card.id,
                action_type: card.action_type,
                image: card.image_url, // `image_url` を `image` に変換
                name: card.name,
                is_tokka: card.is_tokka,
                card_type: card.card_type,
                shipping_schedule: card.shipping_schedule || '',
                title: card.title || '',
                rarity_label: card.rarity, // `rarity` を `rarity_label` に変換
                buy_point: card.buy_point || 0, // デフォルト値を設定
                num: card.num || 1, // デフォルト値を設定
                model_number: card.model_number, // `model_number` を追加
                duplication: card.duplication, // `duplication` を追加
              }))
            "
            :isCoin="
              currentPackHistory &&
                currentPackHistory.pack_name == '引換所の景品'
            "
            :shipping_type="'4'"
          />
          <!-- @selectCard="handleDetailCard" -->
        </div>
        <BoxPager
          v-if="cardList && cardList.page.pages.length > 1"
          class="box-pager"
          :totalPageCount="cardList.page.all_page"
          :currentPageCount="cardList.page.page"
          :dispBoxCount="cardList.page.pages.length"
          :pages="cardList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>
      <div v-if="currentPack" class="detail_area">
        <!-- 以下カードの下詳細部分左側 -->
        <div class="detail_left">
          <div class="count01">
            <span class="c01">
              <div class="image">
                <img src="/img/star_coin.webp" />
              </div>
              {{ currentPack.point | comma
              }}<span v-if="currentPack.payment_method == '1'"></span>
              <span v-if="currentPack.payment_method == '2'">coins</span>
              <!-- / {{ t('1回') }}</span> -->
              </span>
          </div>
          <div class="count02">
            <div class="">
              {{ t('残数') }} {{ currentPack.pack_count | comma }} /
              {{ currentPack.total_pack_count | comma }}
            </div>
          </div>
          <GachaBarGraph
            class="gacha-bar"
            :maxValue="Number(currentPack.total_pack_count)"
            :currentValue="Number(currentPack.pack_count)"
          />
        </div>
        <!-- 以下右側 -->
        <div class="detail_right">
          <div class="gray_area">
            <div class="point_base_area">
              <div class="count_base_area_block">
                <ErrorMessage
                  v-if="errorMessageCount"
                  class="error-message"
                  :message="errorMessageCount"
                />
                <div class="count_base_area">
                  <div class="area count_area">
                    <SelectBox
                      class="select_box"
                      :class="{'disabled' : !remainingBuyCount }"
                      :options="buyList"
                      selectedOption="1"
                      @handleSelectChange="changeCount"
                    />
                    <BuyButton
                      :isShine="true"
                      class="purchase-btn"
                      :isArrow="false"
                      @handleSquareBtnClick="goToConfirmBuyProduct"
                    />
                  </div>
                  <div class="limit_message" v-if="currentPack.can_limit === 1">
                    {{ currentPack.limit_message }}
                  </div>
                </div>
                <div class="limit_message" v-if="errorMessageCount">
                  {{ t(errorMessageCount) }}
                </div>
                <div class="countdown" v-if="isCountdown">
                  <span class="label_title">{{ t('販売開始まで') }}</span>
                  <span class="num">{{ countdownStr }}</span>
                </div>
                <div v-if="currentPack.format_end_date" class="end_date">
                  <span>
                    <span class="end_date_day">{{ formattedSaleText }} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 以下カードをクリックしたら表示されるポップアップ-->
      <!-- <div v-if="showCardDetail" class="popup_card_area" @click.self="showCardDetail = false">
        <div class="popup_card">
          <div class="left">
            <img :src="popupCardData.image">
          </div>
          <div class="right">
            <div>{{popupCardData.name}}</div>
            <div>{{popupCardData.model_number}}</div>
            <div>{{popupCardData.rarity_label}}</div>
          </div>
        </div>
      </div> -->
    </div>
    <CommonOverlay class="overlay_conf" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <GrayCloseButton
          class="close_button"
          @handleClick="closeModal"
        ></GrayCloseButton>
        <div class="block">
          <div>{{ buyCoin | comma }}{{ t('コインを') }}</div>
          <div>
            {{ t('消費して') }}<br />{{ count }}{{ t('回ガチャを引く') }}
          </div>
        </div>
        <div class="modal-button-area">
          <SimpleButton
            class="purchase-btn"
            :isArrow="false"
            @handleSquareBtnClick="buyPack"
          />
          <SimpleButton
            class="purchase-btn cancel-btn"
            :isArrow="false"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closeModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title03.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import t from '@/plugins/i18n';
import GachaBarGraph from '@/components/atoms/GachaBarGraph.vue';
import { shopLink } from '@/common/config/js/const';
import BuyButton from '@/components/atoms/BuyButton.vue';
import CardList from '@/components/organisms/CardList.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import GrayCloseButton from '@/components/atoms/GrayCloseButton.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';

export default {
  name: 'PackDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    SelectBox,
    Title,
    BoxPager,
    BuyButton,
    GachaBarGraph,
    CardList,
    CommonOverlay,
    CommonModal,
    GrayCloseButton,
    SimpleButton,
  },

  data: () => ({
    isOpenModal: false,
    errorMessageCount: null,
    count: 1,
    // showCardDetail: false,
    isOpenConfirm: false,
    popupCardData: {},
    isCountdown: false,
    countdownStr: '',
    page: 1,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      currentPackCardList: 'pack/packCardList',
      packCheckResult: 'pack/packCheckResult',
      setCheckPackResult: 'pack/setCheckPackResult',
      buyPackResult: 'pack/buyPackResult',
      currentPackHistory: 'pack/currentPackHistory',
    }),
    remainingBuyCount() {
      // 購入制限がある場合の残り回数チェック
      const maxBuyCount = parseInt(this.currentPack.max_buy_count, 10);
      const remainingBuyCount = parseInt(this.currentPack.buy_count, 10);
      // 購入制限があり、残り回数が0の場合は選択肢を空にする
      if (maxBuyCount > 0 && remainingBuyCount === 0) {
        return false;
      }
      return true;
    },
    cardList() {
      if (this.currentPackCardList) {
        return this.currentPackCardList;
      }
      return { list: [], page: { pages: [] } };
    },
    isAvailable() {
      return (parseInt(this.currentUser.point, 10) >= parseInt(this.currentPack.point, 10));
    },
    packCount() {
      if (this.currentPack) {
        return separateCharacterNumber(this.currentPack.pack_count);
      }
      return 0;
    },
    buyList() {
      if (!this.packCount) {
        return [];
      }
      const count = parseInt(this.packCount.replace(',', ''), 10);
      let max = count;
      if (max > 3000) {
        max = 3000;
      }
      const maxCount = parseInt(this.currentPack.max_buy_count, 10);
      if (maxCount > 0 && max > maxCount) {
        max = maxCount;
      }
      const option = [];
      for (let i = 1; i <= max; i += 1) {
        // option.push({ id: i, name: `${i}${this.t('パック')}` });
        option.push({ id: i, name: `${i}` });
      }
      return option;
    },
    formattedSaleText() {
      const dateText = this.currentPack.format_end_date;
      if (!dateText) return '';
      const date = new Date(dateText.replace(/-/g, '/'));
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const key = '{year}/{month}/{day} まで販売';
      const lang = this.currentUser?.language;
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template
        .replace('{year}', year)
        .replace('{month}', month)
        .replace('{day}', day);
    },
    buyCoin() {
      if (this.currentPack) {
        return this.currentPack.point * this.count;
      }
      return 0;
    },
  },
  created() {
    const { errorMessageCount } = this.$route.query;
    this.errorMessageCount = errorMessageCount ? errorMessageCount[0] : null;
    this.$store.dispatch('pack/setCurrentPack', {
      packId: this.$route.query.packId,
    });
    if (this.$route.query.packId) {
      this.$store.dispatch('pack/setPackCardList', {
        packId: this.$route.query.packId,
        pageNumber: 1,
      });
    }
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaFloat(value) {
      return separateDecimalNumber(value, true);
    },
  },

  watch: {
    packCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          this.$store.dispatch('pack/clearPackCheckResult');
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          this.isOpenModal = true;
        }
      }
    },
    currentPack(newVal) {
      if (newVal) {
        if (!newVal.id) {
          window.location.href = '/';
        }
        if (newVal.is_before) {
          this.isCountdown = true;
          this.setTimerID = setInterval(() => {
            this.setCountdownString();
          }, 1000);
          this.setCountdownString();
          // this.scrollToTop();
        }
      }
    },
    currentPackCardList(newVal) {
      if (newVal) {
        window.scrollTo(0, 0);
      }
    },
  },

  beforeDestroy() {
    // タイマーをクリーンアップ
    if (this.setTimerID) {
      clearInterval(this.setTimerID);
    }
  },

  methods: {
    scrollToTop() {
      this.$nextTick(() => {
        const el = this.$refs.scrollTarget;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    setCountdownString() {
      const day1 = new Date(this.currentPack.start_date.replace(/-/g, '/'));
      const day2 = new Date();
      const diffDay = day1 - day2;
      if (diffDay < 0) {
        this.isCountdown = false;
        clearInterval(this.setTimerID);
        return;
      }
      const h = `0${parseInt(diffDay / (1000 * 60 * 60), 10)}`.slice(-2);
      const m = `0${parseInt(
        (diffDay % (1000 * 60 * 60)) / (1000 * 60),
        10,
      )}`.slice(-2);
      const s = `0${parseInt((diffDay % (1000 * 60)) / 1000, 10)}`.slice(-2);
      this.countdownStr = `${h}.${m}.${s}`;
    },
    changeCount(val) {
      this.count = parseInt(val, 10);
    },
    closeModal() {
      this.isOpenModal = false;
      this.isOpenConfirm = false;
    },
    goToBuyPoint() {
      // ポイント購入画面へ
      const query = { packId: this.$route.query.packId };
      this.$router.push({ path: '/buy-point', query });
    },
    goToConfirmBuyProduct() {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/' });
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }
      const postParams = {
        pack_id: this.currentPack.id,
        count: String(this.count),
      };
      this.$store.dispatch('pack/setCheckPackResult', { postParams });
    },
    changeCurrentPageCount(page) {
      this.page = page;
      this.$store.dispatch('pack/setPackCardList', { packId: this.currentPack.id, pageNumber: page });
      // this.scrollToTop();
    },
    // handleDetailCard(card) {
    //   this.popupCardData = card;
    //   this.showCardDetail = true;
    // },
    buyPack() {
      if (this.currentUser.is_login === '0') {
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }
      this.localBuyPack();
    },
    localBuyPack() {
      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { result } = buyPackResult;
          const { count } = buyPackResult.errors;
          if (result === -100) {
            this.localBuyPack();
            return;
          }
          window.alert(this.t(count));
          this.isOpenConfirm = false;
        }
      })();
    },
    setShopLink(detail) {
      let result = detail;
      Object.keys(shopLink).forEach((key) => {
        const regex = new RegExp(key.replace(/[()]/g, '\\$&'), 'g');
        result = result.replace(
          regex,
          `<a href="${shopLink[key]}" target="_blank">${key}</a>`,
        );
      });
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.pack-detail {
  width: 100%;
  max-width: 900px;
  min-height: 100vh;
  padding: 0 0 26px 0;
  margin: 0 auto;
  color: $mainColor;
  .card_list_area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 90px;
    margin-top: 20px;
    .card_list {
      flex-grow: 1;
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 150px;
        margin: 2px;
      }
    }
    .list_comment {
      margin: 20px 0;
      text-align: center;
    }
  }
  .detail_area {
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    z-index: 1;
    border-radius: 8px;
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 8px;
      padding: 2px;
      background: linear-gradient(to right, #f4ec4d, #e3a735, #d91e1b);
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }
    .detail_left {
      padding-bottom: 10px;
      flex: 1;
      align-items: center;
      display: flex;
      flex-direction: column;
      color: #717071;
      font-weight: bold;
      .count01 {
        .c01 {
          display: flex;
          align-items: center;
          font-size: 30px;
          margin-right: 20px;
          .image {
            margin-top: 8px;
            width: 55px;
            img {
              width: 60px;
            }
          }
        }
      }
      .count02 {
        margin-bottom: 5px;
        font-size: 25px;
      }
      .gacha-bar {
        width: 60% !important;
      }
      .detail_block {
        margin-top: 40px;
      }
      .container {
        width: 80%;
      }
    }
    .detail_right {
      flex: 1.2;
      align-items: center;
      display: flex;
      flex-direction: column;
      .count_base_area_block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .count_base_area {
          .count_area {
            display: flex;
            padding-bottom: 10px;
            border-bottom: solid 1px $white;
            span {
              font-size: 24px;
            }
          }
        }
      }
      .gray_area {
        padding: 20px;
        .count_area {
          display: flex;
          align-items: center;
          gap: 10px;
          padding-bottom: 10px;
          .select_box {
            min-width: 150px;
            padding: 3px;
            &.disabled {
              padding: 0px;
              background-color: #cccccc;
              pointer-events: none;
              opacity: 0.5;
            }
          }
          .purchase-btn {
            padding: 14px 20px;
            min-width: 140px;
            white-space: nowrap;
          }
        }
      }
      .point_area {
        padding: 10px 0;
        .point {
          font-size: 24px;
        }
        span {
          font-size: 20px;
        }
      }
      .end_date {
        // text-align: center;
        // margin-top: 20px;
        // color: red;
        font-weight: bold;
        .end_date_txt {
          background-color: #e60012;
          color: $white;
          padding: 3px 10px;
        }
        .end_date_day {
          white-space: nowrap;
          background-color: $white;
          color: #b81a24;
          padding: 3px 10px;
        }
      }
    }
  }
} //_______________________________________________\
.popup_card_area {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000;
  .popup_card {
    padding: 20px 40px;
    background-color: #fff;
  }
}
.modal {
  box-shadow: 10px 10px 10px 5px rgba(0, 0, 0, 0.6);
  width: auto;
  padding: 30px 30px;
  color: $mainColor;
  font-size: 20px;
  .modal-button-area {
    margin-top: 20px;
  }
}
.pack-confirm {
  border-radius: 10px;
  max-width: 600px;
  min-width: 400px;
  padding: 30px;
  position: relative;
  .block {
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 10px 20px;
    font-weight: bold;
    color: $gray2;
    text-align: center;
    div {
      text-align: center;
    }
  }
  .close_button {
    position: absolute;
    right: 7px;
    top: 15px;
  }
  @media screen and (max-width: $mobileWidth) {
    max-width: 90vw;
    min-width: 320px;
    padding: 40px 20px;
    min-height: 400px;
    .block {
      padding: 20px 10px;
    }
  }
}
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .modal-button-area {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: 30px;
    margin-top: 40px;
    .purchase-btn {
      width: 48%;
    }
    @media screen and (max-width: $mobileWidth) {
      flex-direction: column;
      margin: 40px 0;
      align-items: center;
      gap: 25px;
      .purchase-btn {
        width: 100%;
        max-width: 165px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .pack-detail {
    .card_list_area {
      padding-bottom: 0px;
      .card_list {
        display: flex;
        margin-bottom: 20px;
        img {
          width: auto !important;
          height: 90px;
          margin: 2px;
        }
      }
    }
    .detail_area {
      bottom: 68px;
      .detail_left {
        .count01 {
          .c01 {
            font-size: 24px;
          }
        }
        .count02 {
          font-size: 20px;
        }
        .point_base_area {
          flex-direction: column;
          margin-top: 0;
          .point_area {
            width: 100%;
            text-align: center;
          }
          .count_base_area_block {
            width: 100% !important;
            padding: 0;
            .count_base_area {
              flex-direction: column;
              align-items: center;
              .count_area {
                margin: 20px 0;
              }
            }
          }
        }
      }
      .detail_right {
        .count_area {
          .select_box {
            min-width: 90px !important;
          }
          .purchase-btn {
            min-width: 110px !important;
          }
        }
        .countdown {
          font-size: 18px;
          flex-direction: column;
          span.num {
            font-size: 24px;
          }
          .purchase-btn {
            min-width: 80px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .card_list_area {
    .card_list {
      img {
        height: 100px !important;
      }
    }
  }
  .detail_area {
    .detail_left {
      .count01 {
        .c01 {
          margin-right: 0px !important;
          font-size: 15px !important;
          .image {
            width: 35px !important;
            margin-top: 5px !important;
            img {
              width: 35px !important;
            }
          }
        }
      }
      .count02 {
        font-size: 15px !important;
      }
    }
    .detail_right {
      .gray_area {
        padding: 5px !important;
        .count_area {
          display: flex;
          align-items: center;
          gap: 10px;
          .purchase-btn {
            min-width: 70px !important;
            padding: 12px 18px !important;
          }
        }
        .end_date {
          font-size: smaller;
        }
      }
    }
  }
}
</style>
